import React from "react"
import ReactLoading from "react-loading"
import makeStyles from "../muiStylesCompat"
import FlexBox from "./FlexBox"
import Logo from "./Logo"

const useStyles = makeStyles({
    background: {
        backgroundColor: "white",
    },
})

export default function LoadingScreen() {
    const classes = useStyles()
    return (
        <FlexBox
            className={classes.background}
            flex={1}
            justifyContent="center"
        >
            <FlexBox flexDirection="column" justifyContent="center">
                <FlexBox alignItems="center">
                    <Logo invert={true} />
                    <ReactLoading type="spinningBubbles" color="#f95744" />
                </FlexBox>
            </FlexBox>
        </FlexBox>
    )
}
